/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { UserService } from '../../services/user.service';
import { DataService } from '../../services/data.service';
import { DataFormatterService } from 'src/app/common/data-formatter.service';
import { ChartService } from '../../services/chart.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { ErrorService } from '../../services/error.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-user-logo',
  templateUrl: './user-logo.component.html',
  styleUrls: ['./user-logo.component.scss'],
})
export class UserLogoComponent implements OnInit {

  userMode: boolean = true;
  trainerMode: boolean = false;

  passcodeForm: FormGroup;
  isProfileOpen: boolean = false;
  isPasscodeOpen: boolean = false;
  resetConfirm: boolean = false;
  oldPasscodeError: string = "";
  newPasscodeError: string = "";
  confirmPasscodeError: string = "";
  confirmPasscode: boolean = false;
  resetPasscodeDetails: any;
  @Output() addConversation: EventEmitter<{ newConversation: boolean,}> = new EventEmitter();
  
  constructor( public modalController: ModalController,
    public utilService:UtilsService,private userService:UserService,private dataService:DataService,private dfs: DataFormatterService,private chartService:ChartService,private errorService: ErrorService,) {
    this.passcodeForm = new FormGroup({
          oldPasscode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6,}$')]),
          newPasscode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6,}$')]),
          confirmPasscode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{6,}$')]),
        });
   }

  ngOnInit() {
    this.utilService.getTrainerMode();
    this.userMode = !this.userService.getTrainerMode();
    this.trainerMode = this.userService.getTrainerMode();
  }
  switchMode(value: boolean) {
    this.userMode = value;
    this.trainerMode = !value
    this.userService.setTrainerMode(this.trainerMode);
    this.utilService.getTrainerMode();
    // window.location.reload();
    this.addConversation.emit({ newConversation: true });
    this.utilService.conversationTitle = 'New Chat'
    this.utilService.selectedIndex = -1;
    this.utilService.isNewConversations = false;
    this.dataService.getAllConversations().subscribe((res) => {
      this.utilService.Conversations = this.dfs.sortResultsByNumber(res.data);

      this.utilService.lessConversation = this.utilService.Conversations.length > 5 ? true : false
      this.utilService.deleteAllEnabled = this.utilService.Conversations.length > 1 ? true : false
      this.utilService.updatedConversations = this.utilService.Conversations.slice(0, 5);

    },
      (err) => {
        console.log(err);
      })
    this.chartService.filterResultData = [];

  }
  profileModalOpen(value: boolean) {
    this.isProfileOpen = true
  }
  async modalDismiss() {
    this.isProfileOpen = false;
  }
  passcodeModalOpen() {
    this.isProfileOpen = false;
    this.isPasscodeOpen = true;

  }
  reset() {
    console.log( this.resetConfirm)
    this.updateErrorMessages();
    this.resetConfirm = true;
    this.isPasscodeOpen = false;
    if (this.passcodeForm.valid) {

      this.resetPasscodeDetails = this.passcodeForm.value;
    }

  }
  updateErrorMessages() {

    if (this.passcodeForm.get('oldPasscode')?.hasError('required') && this.passcodeForm.get('oldPasscode')?.touched) {
      this.oldPasscodeError = "Old passcode is required.";
    } else if (this.passcodeForm.get('oldPasscode')?.hasError('pattern') && this.passcodeForm.get('oldPasscode')?.touched) {
      this.oldPasscodeError = "Old passcode must contain at least 6 digits and only numbers.";
    } else {
      this.oldPasscodeError = "";
    }


    if (this.passcodeForm.get('newPasscode')?.hasError('required') && this.passcodeForm.get('newPasscode')?.touched) {
      this.newPasscodeError = "New passcode is required.";
    } else if (this.passcodeForm.get('newPasscode')?.hasError('pattern') && this.passcodeForm.get('newPasscode')?.touched) {
      this.newPasscodeError = "New passcode must contain at least 6 digits and only numbers.";
    } else {
      this.newPasscodeError = "";
    }


    if (this.passcodeForm.get('confirmPasscode')?.hasError('required') && this.passcodeForm.get('confirmPasscode')?.touched) {
      this.confirmPasscodeError = "Please confirm your passcode.";
    } else if (this.passcodeForm.get('confirmPasscode')?.hasError('pattern') && this.passcodeForm.get('confirmPasscode')?.touched) {
      this.confirmPasscodeError = "Confirm passcode must contain at least 6 digits and only numbers.";
    } else if (this.passcodeForm.get('confirmPasscode')?.value !== this.passcodeForm.get('newPasscode')?.value && this.passcodeForm.get('confirmPasscode')?.touched) {
      this.confirmPasscodeError = "Passcodes do not match.";
      this.confirmPasscode = true
    } else {
      this.confirmPasscodeError = "";
    }
  }

  isResetDisabled() {

    if (
      !this.passcodeForm.valid ||
      (this.passcodeForm.get('confirmPasscode')?.value !== this.passcodeForm.get('newPasscode')?.value)
    ) {
      return true;
    }

    return false;
  }
  resetClose() {
    this.resetConfirm = false;
    this.isProfileOpen = false;
    this.isPasscodeOpen = true;
  }
  resetPassword() {
    this.utilService.dataLoaded = false
    this.dataService.resetPasscode(this.resetPasscodeDetails['oldPasscode'], this.resetPasscodeDetails['newPasscode']).subscribe((res) => {
      this.resetConfirm = false;
      this.utilService.dataLoaded = true;
      this.modalController.dismiss()
      this.utilService.logout();
    }, (err) => {
      this.utilService.dataLoaded = true;
      this.confirmPasscodeError = this.errorService.errorMessage
      this.isPasscodeOpen = true;
      this.resetConfirm = false;
    })

  }
  logout(): void {
    this.utilService.logout();
  }
  onFieldBlur() {
    this.updateErrorMessages();
  }
  passcodeModalClose() {

    this.isPasscodeOpen = false;
    this.isProfileOpen = true;
    this.passcodeForm.reset();
    this.oldPasscodeError = this.newPasscodeError = this.confirmPasscodeError = ""

  }

}
